<template>
  <div>
    <BackgroundImageSettings
      v-if="activeTabNode"
      :tab-node="activeTabNode"
    />
    <InfoCardSettings
      v-if="activeTabNode"
      :tab-node="activeTabNode"
    />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BackgroundImageSettings from '@/components/builder/CustomVisualisationSettings/BackgroundImageSettings.vue'
import InfoCardSettings from '@/components/builder/CustomVisualisationSettings/InfoCardSettings.vue'

const components = {
  BackgroundImageSettings,
  InfoCardSettings,
}

@Component({ components })
export default class CustomVisualisationSettingsView extends Vue {
  get activeTabNode () {
    return this.$typedStore.primary.entities.nodes.activeCustomTabNode
  }
}

</script>
